export default function About() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Sobre el Instituto
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          <p className="text-base text-gray-700 leading-relaxed mb-6">
            El <strong>Instituto de Clínica Médica (ICM)</strong> es un centro de atención médica dedicado a la atención clínica del adulto, con un enfoque profesional en medicina interna y especialidades relacionadas.
          </p>
          <p className="text-base text-gray-700 leading-relaxed mb-6">
            Nuestro equipo de profesionales altamente capacitados brinda atención integral, priorizando el seguimiento médico continuo y la prevención de enfermedades.
          </p>
          <p className="text-base text-gray-700 leading-relaxed mb-12">
            Nos comprometemos a ofrecer un servicio de calidad, con calidez humana y tecnología actualizada, para garantizar el bienestar de nuestros pacientes.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="bg-blue-50 rounded-lg p-6">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i className="ri-user-heart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2 text-center">Atención Personalizada</h3>
              <p className="text-sm text-gray-600 text-center">Seguimiento continuo de cada paciente</p>
            </div>

            <div className="bg-blue-50 rounded-lg p-6">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i className="ri-stethoscope-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2 text-center">Profesionales Expertos</h3>
              <p className="text-sm text-gray-600 text-center">Equipo médico altamente calificado</p>
            </div>

            <div className="bg-blue-50 rounded-lg p-6">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i className="ri-heart-pulse-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2 text-center">Prevención</h3>
              <p className="text-sm text-gray-600 text-center">Enfoque en medicina preventiva</p>
            </div>

            <div className="bg-blue-50 rounded-lg p-6">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i className="ri-hospital-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2 text-center">Instalaciones</h3>
              <p className="text-sm text-gray-600 text-center">Equipamiento moderno y confortable</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}